import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiService from '../../../../global/services/api.service';
import { ListResponseDTO } from '../../../../global';
import { TripDTO, TripFilter } from '../types/trip';
import { parseTripsWithMessages } from '../utils/parse-with-trip-messages';
import { prepareTripsList } from '../utils/prepare-trip-list';
import { calculateOverallTrip } from '../utils/calculate-overall-trip';

export const getTrips = createAsyncThunk(
  'trip/getTrips',
  async (body: TripFilter, thunkAPI) => {
    const { data } = await ApiService.post<ListResponseDTO<TripDTO>>(
      `/trips/search?includeMessages=${body.includeMessages}`,
      body.query,
      { signal: thunkAPI.signal },
    );

    const filteredTrips = await parseTripsWithMessages(data.items);
    const all = prepareTripsList(filteredTrips);
    const overallTrip = calculateOverallTrip(filteredTrips);

    return {
      all,
      overallTrip,
    };
  },
);

export const getTrip = createAsyncThunk('trip/getTrip', async (id: number) => {
  const { data } = await ApiService.get<TripDTO>(`/trips/${id}`);

  const filteredTrips = await parseTripsWithMessages([data]);

  return filteredTrips[0];
});
